// @flow

import React, { Component, createContext } from 'react';

type Props = {
  children: () => Node | Node[],
};

const ModalContext = createContext({
  components: [],
  showModal: () => {},
  hideModal: () => {},
});

export class ModalProvider extends Component<Props> {
  state = {
    components: [],
  };

  showModal = (component, props = {}) => {
    this.setState({
      components: this.state.components.concat([
        { Component: component, props },
      ]),
    });
  };

  hideModal = () => {
    const arrComponents = [...this.state.components];
    arrComponents.pop();
    this.setState({
      components: arrComponents,
    });
  };

  render() {
    return (
      <ModalContext.Provider
        value={{
          ...this.state,
          showModal: this.showModal,
          hideModal: this.hideModal,
        }}
      >
        {this.props.children}
      </ModalContext.Provider>
    );
  }
}

export const ModalConsumer = ModalContext.Consumer;



// WEBPACK FOOTER //
// /opt/build/repo/src/packages/modal/components/ModalPovider.js